/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimCenterBookableScheduleException
 */
export interface ClaimCenterBookableScheduleException {
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterBookableScheduleException
     */
    reason: string;
    /**
     * ISO8601 local time string, e.g. 17:30
     * @type {string}
     * @memberof ClaimCenterBookableScheduleException
     */
    localEndTime: string;
    /**
     * ISO8601 local time string, e.g. 17:30
     * @type {string}
     * @memberof ClaimCenterBookableScheduleException
     */
    localStartTime: string;
    /**
     * ISO8601 local date string , e.g. 2025-04-16
     * @type {string}
     * @memberof ClaimCenterBookableScheduleException
     */
    localDate: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterBookableScheduleException
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterBookableScheduleException
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterBookableScheduleException
     */
    claimCenterBookableId: string;
}

/**
 * Check if a given object implements the ClaimCenterBookableScheduleException interface.
 */
export function instanceOfClaimCenterBookableScheduleException(value: object): value is ClaimCenterBookableScheduleException {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('localEndTime' in value) || value['localEndTime'] === undefined) return false;
    if (!('localStartTime' in value) || value['localStartTime'] === undefined) return false;
    if (!('localDate' in value) || value['localDate'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimCenterBookableId' in value) || value['claimCenterBookableId'] === undefined) return false;
    return true;
}

export function ClaimCenterBookableScheduleExceptionFromJSON(json: any): ClaimCenterBookableScheduleException {
    return ClaimCenterBookableScheduleExceptionFromJSONTyped(json, false);
}

export function ClaimCenterBookableScheduleExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterBookableScheduleException {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'localEndTime': json['localEndTime'],
        'localStartTime': json['localStartTime'],
        'localDate': json['localDate'],
        'customerId': json['customerId'],
        'id': json['id'],
        'claimCenterBookableId': json['claimCenterBookableId'],
    };
}

export function ClaimCenterBookableScheduleExceptionToJSON(value?: ClaimCenterBookableScheduleException | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
        'localEndTime': value['localEndTime'],
        'localStartTime': value['localStartTime'],
        'localDate': value['localDate'],
        'customerId': value['customerId'],
        'id': value['id'],
        'claimCenterBookableId': value['claimCenterBookableId'],
    };
}

